import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { IBuyTicketsAppState } from '../redux-state';

import { ICalendarAppBaseText } from '../classes/buytickets-text';

import LoaderView from '../views/loader.view';

interface IExternalProps {
}

interface StateToProps {
    text: ICalendarAppBaseText;
    isLoading: boolean;
}

interface DispatchToProps {
}

export type LoaderProps = IExternalProps & StateToProps;

export const LoaderBase: React.StatelessComponent<LoaderProps> = props => {
    return (
        <LoaderView {...props} />
    )
}

function mapStateToProps(state: IBuyTicketsAppState, ownProps: IExternalProps): StateToProps {
    return {
        text: state.calendarText,
        isLoading: state.calendar.updating
    }
}

export default connect(mapStateToProps)(LoaderBase);